// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.quick-invite-overlay {
  position: fixed;
  inset: 0;
  /* Above route/call shells and same-level preview overlays. A later
     contact picker portal must remain above this invite, not behind it. */
  z-index: 2147483001;
  display: grid;
  place-items: center;
  padding: 16px;
  background: rgb(8 10 14 / 78%);
}

/* The nested contact picker is also portaled to body. Its shared stylesheet
   uses the preview z-index; elevate only the picker belonging to an open
   quick invite, without changing other invite screens. */
.quick-invite-overlay ~ .contact-import-overlay {
  z-index: 2147483002;
}

.quick-invite-dialog {
  display: flex;
  flex-direction: column;
  width: min(100%, 440px);
  max-height: calc(100dvh - 32px);
  overflow: hidden;
  color: #e0dfd8;
  background: #111318;
  border: 2px solid #fff;
  border-radius: 14px;
  box-shadow: 0 20px 60px rgb(0 0 0 / 55%);
}

.quick-invite-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 17px 18px;
  background: #0d0f14;
  border-bottom: 2px solid #fff;
}

.quick-invite-title {
  display: flex;
  gap: 9px;
  align-items: center;
  margin: 0;
  color: #fff;
  font-size: 18px;
}

.quick-invite-title .call-icon {
  color: #4ade80;
}

.quick-invite-close {
  display: inline-flex;
  height: 36px;
  min-width: 76px;
  padding: 0 14px;
  align-items: center;
  justify-content: center;
  color: #d8e2e5;
  font: inherit;
  font-size: 14px;
  font-weight: 600;
  background: transparent;
  border: 2px solid #fff;
  border-radius: 8px;
  cursor: pointer;
}

.quick-invite-body {
  padding: 18px;
  overflow-y: auto;
}

.quick-invite-hint {
  margin: 0 0 14px;
  color: #c8c8c0;
  font-size: 14px;
  line-height: 1.55;
}

.quick-invite-label {
  display: block;
  margin-bottom: 6px;
  color: #d6dfe2;
  font-size: 12px;
  font-weight: 700;
}

.quick-invite-emails {
  box-sizing: border-box;
  width: 100%;
  min-height: 72px;
  padding: 11px 13px;
  color: #fff;
  font: inherit;
  line-height: 1.45;
  white-space: pre-wrap;
  overflow-y: auto;
  background: #0a0c12;
  border: 2px solid #fff;
  border-radius: 9px;
}

.quick-invite-emails:empty::before {
  content: attr(data-placeholder);
  color: #8c979e;
  pointer-events: none;
}

.quick-invite-emails:focus-visible,
.quick-invite-close:focus-visible,
.quick-invite-send:focus-visible,
.quick-invite-sms-link-copy:focus-visible {
  outline: 3px solid #36ddb0;
  outline-offset: 2px;
}

.quick-invite-contacts {
  display: flex;
  gap: 11px;
  align-items: center;
  min-height: 58px;
  margin-top: 16px;
  padding: 9px 12px;
  background: #181b24;
  border: 2px solid #fff;
  border-radius: 9px;
}

.quick-invite-contacts-icon {
  flex: none;
  display: grid;
  width: 36px;
  height: 36px;
  place-items: center;
  color: #4ade80;
  background: #0d2118;
  border: 2px solid #1d9e75;
}

.quick-invite-contacts-copy {
  display: grid;
  flex: 1;
  gap: 3px;
  min-width: 0;
  color: #99a4aa;
  font-size: 12px;
}

.quick-invite-contacts-copy strong {
  color: #fff;
  font-size: 14px;
}

.quick-invite-contacts .contact-import-btn {
  margin: 0;
  white-space: nowrap;
}

.quick-invite-footer {
  flex: none;
  padding: 18px;
  background: #0d0f14;
  border-top: 2px solid #fff;
}

.quick-invite-send {
  display: inline-flex;
  gap: 9px;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 54px;
  color: #fff;
  font-size: 16px;
  font-weight: 800;
  background: #1d9e75;
  border: 3px solid #4ade80;
  border-radius: 12px;
  cursor: pointer;
}

.quick-invite-send:hover:not(:disabled) {
  background: #64e5bc;
}

.quick-invite-send:disabled {
  cursor: wait;
  opacity: .6;
}

.quick-invite-security-note {
  display: flex;
  gap: 6px;
  align-items: center;
  justify-content: center;
  margin: 12px 0 0;
  color: #aeb9be;
  font-size: 11px;
  text-align: center;
}

.quick-invite-security-note .call-icon {
  width: 14px;
  height: 14px;
  color: #55d7aa;
}

.quick-invite-error,
.quick-invite-notice,
.quick-invite-sms-links,
.quick-invite-sms-no-link {
  margin-top: 12px;
  font-size: 12px;
}

.quick-invite-error {
  color: #ff9c9c;
}

.quick-invite-notice {
  color: #65e2af;
}

.quick-invite-sms-link-row {
  display: flex;
  gap: 6px;
  align-items: center;
  margin-top: 6px;
}

.quick-invite-sms-link-url {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.quick-invite-sms-link-copy {
  padding: 5px 8px;
  color: #dff9f0;
  background: #263038;
  border: 1px solid #687a82;
  border-radius: 5px;
}

@media (width <= 520px) {
  .quick-invite-overlay {
    padding: 8px;
  }

  .quick-invite-dialog {
    max-height: calc(100dvh - 16px);
    border-radius: 14px;
  }

  .quick-invite-contacts {
    align-items: flex-start;
    flex-wrap: wrap;
  }

  .quick-invite-contacts .contact-import {
    width: 100%;
  }
}

/* Keep contact sources in the dialog's scroll flow on touch devices. Floating
   menus are clipped by iOS Safari when the software keyboard is open. */
@media (width <= 768px) {
  .quick-invite-dialog .contact-import {
    display: block;
  }

  .quick-invite-dialog .contact-import-menu {
    position: static;
    width: 100%;
    min-width: 0;
    margin-top: 6px;
  }
}`, "",{"version":3,"sources":["webpack://./src/magic-link/QuickInviteDialog.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,QAAQ;EACR;0EACwE;EACxE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,8BAA8B;AAChC;;AAEA;;yDAEyD;AACzD;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,+BAA+B;EAC/B,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,sBAAsB;EACtB,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;EAC/B,cAAc;EACd,oBAAoB;AACtB;;AAEA;;;;EAIE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,oBAAoB;EACpB,QAAQ;EACR,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;;;;EAIE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,+BAA+B;IAC/B,mBAAmB;EACrB;;EAEA;IACE,uBAAuB;IACvB,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;wEACwE;AACxE;EACE;IACE,cAAc;EAChB;;EAEA;IACE,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;AACF","sourcesContent":[".quick-invite-overlay {\n  position: fixed;\n  inset: 0;\n  /* Above route/call shells and same-level preview overlays. A later\n     contact picker portal must remain above this invite, not behind it. */\n  z-index: 2147483001;\n  display: grid;\n  place-items: center;\n  padding: 16px;\n  background: rgb(8 10 14 / 78%);\n}\n\n/* The nested contact picker is also portaled to body. Its shared stylesheet\n   uses the preview z-index; elevate only the picker belonging to an open\n   quick invite, without changing other invite screens. */\n.quick-invite-overlay ~ .contact-import-overlay {\n  z-index: 2147483002;\n}\n\n.quick-invite-dialog {\n  display: flex;\n  flex-direction: column;\n  width: min(100%, 440px);\n  max-height: calc(100dvh - 32px);\n  overflow: hidden;\n  color: #e0dfd8;\n  background: #111318;\n  border: 2px solid #fff;\n  border-radius: 14px;\n  box-shadow: 0 20px 60px rgb(0 0 0 / 55%);\n}\n\n.quick-invite-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 17px 18px;\n  background: #0d0f14;\n  border-bottom: 2px solid #fff;\n}\n\n.quick-invite-title {\n  display: flex;\n  gap: 9px;\n  align-items: center;\n  margin: 0;\n  color: #fff;\n  font-size: 18px;\n}\n\n.quick-invite-title .call-icon {\n  color: #4ade80;\n}\n\n.quick-invite-close {\n  display: inline-flex;\n  height: 36px;\n  min-width: 76px;\n  padding: 0 14px;\n  align-items: center;\n  justify-content: center;\n  color: #d8e2e5;\n  font: inherit;\n  font-size: 14px;\n  font-weight: 600;\n  background: transparent;\n  border: 2px solid #fff;\n  border-radius: 8px;\n  cursor: pointer;\n}\n\n.quick-invite-body {\n  padding: 18px;\n  overflow-y: auto;\n}\n\n.quick-invite-hint {\n  margin: 0 0 14px;\n  color: #c8c8c0;\n  font-size: 14px;\n  line-height: 1.55;\n}\n\n.quick-invite-label {\n  display: block;\n  margin-bottom: 6px;\n  color: #d6dfe2;\n  font-size: 12px;\n  font-weight: 700;\n}\n\n.quick-invite-emails {\n  box-sizing: border-box;\n  width: 100%;\n  min-height: 72px;\n  padding: 11px 13px;\n  color: #fff;\n  font: inherit;\n  line-height: 1.45;\n  white-space: pre-wrap;\n  overflow-y: auto;\n  background: #0a0c12;\n  border: 2px solid #fff;\n  border-radius: 9px;\n}\n\n.quick-invite-emails:empty::before {\n  content: attr(data-placeholder);\n  color: #8c979e;\n  pointer-events: none;\n}\n\n.quick-invite-emails:focus-visible,\n.quick-invite-close:focus-visible,\n.quick-invite-send:focus-visible,\n.quick-invite-sms-link-copy:focus-visible {\n  outline: 3px solid #36ddb0;\n  outline-offset: 2px;\n}\n\n.quick-invite-contacts {\n  display: flex;\n  gap: 11px;\n  align-items: center;\n  min-height: 58px;\n  margin-top: 16px;\n  padding: 9px 12px;\n  background: #181b24;\n  border: 2px solid #fff;\n  border-radius: 9px;\n}\n\n.quick-invite-contacts-icon {\n  flex: none;\n  display: grid;\n  width: 36px;\n  height: 36px;\n  place-items: center;\n  color: #4ade80;\n  background: #0d2118;\n  border: 2px solid #1d9e75;\n}\n\n.quick-invite-contacts-copy {\n  display: grid;\n  flex: 1;\n  gap: 3px;\n  min-width: 0;\n  color: #99a4aa;\n  font-size: 12px;\n}\n\n.quick-invite-contacts-copy strong {\n  color: #fff;\n  font-size: 14px;\n}\n\n.quick-invite-contacts .contact-import-btn {\n  margin: 0;\n  white-space: nowrap;\n}\n\n.quick-invite-footer {\n  flex: none;\n  padding: 18px;\n  background: #0d0f14;\n  border-top: 2px solid #fff;\n}\n\n.quick-invite-send {\n  display: inline-flex;\n  gap: 9px;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  min-height: 54px;\n  color: #fff;\n  font-size: 16px;\n  font-weight: 800;\n  background: #1d9e75;\n  border: 3px solid #4ade80;\n  border-radius: 12px;\n  cursor: pointer;\n}\n\n.quick-invite-send:hover:not(:disabled) {\n  background: #64e5bc;\n}\n\n.quick-invite-send:disabled {\n  cursor: wait;\n  opacity: .6;\n}\n\n.quick-invite-security-note {\n  display: flex;\n  gap: 6px;\n  align-items: center;\n  justify-content: center;\n  margin: 12px 0 0;\n  color: #aeb9be;\n  font-size: 11px;\n  text-align: center;\n}\n\n.quick-invite-security-note .call-icon {\n  width: 14px;\n  height: 14px;\n  color: #55d7aa;\n}\n\n.quick-invite-error,\n.quick-invite-notice,\n.quick-invite-sms-links,\n.quick-invite-sms-no-link {\n  margin-top: 12px;\n  font-size: 12px;\n}\n\n.quick-invite-error {\n  color: #ff9c9c;\n}\n\n.quick-invite-notice {\n  color: #65e2af;\n}\n\n.quick-invite-sms-link-row {\n  display: flex;\n  gap: 6px;\n  align-items: center;\n  margin-top: 6px;\n}\n\n.quick-invite-sms-link-url {\n  flex: 1;\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.quick-invite-sms-link-copy {\n  padding: 5px 8px;\n  color: #dff9f0;\n  background: #263038;\n  border: 1px solid #687a82;\n  border-radius: 5px;\n}\n\n@media (width <= 520px) {\n  .quick-invite-overlay {\n    padding: 8px;\n  }\n\n  .quick-invite-dialog {\n    max-height: calc(100dvh - 16px);\n    border-radius: 14px;\n  }\n\n  .quick-invite-contacts {\n    align-items: flex-start;\n    flex-wrap: wrap;\n  }\n\n  .quick-invite-contacts .contact-import {\n    width: 100%;\n  }\n}\n\n/* Keep contact sources in the dialog's scroll flow on touch devices. Floating\n   menus are clipped by iOS Safari when the software keyboard is open. */\n@media (width <= 768px) {\n  .quick-invite-dialog .contact-import {\n    display: block;\n  }\n\n  .quick-invite-dialog .contact-import-menu {\n    position: static;\n    width: 100%;\n    min-width: 0;\n    margin-top: 6px;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
